import { Subject, BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/api.service';
import { PlatformService } from '../platform/platform.service';
import { CustomLoaderService } from 'src/app/shared/custom-loader/custom-loader.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export abstract class SignalRService {
    eventListener$ = new Subject<{ event: string, datas: any }>();
    notificationsHandled$ = new BehaviorSubject<any[]>([]);

    constructor(
        protected _apiService: ApiService,
        protected _platformService: PlatformService,
        protected _customLoaderService: CustomLoaderService,
    ) {
    }

    abstract doConnectHub(): Promise<void>;
    abstract disconnect(): void;
    abstract isConnected(): boolean;
    abstract authenticate(userId: string, societeId: string): void;
    abstract unauthenticate(): void;
}